import { render, staticRenderFns } from "./releaseDetail.vue?vue&type=template&id=518d22f4&scoped=true"
import script from "./releaseDetail.vue?vue&type=script&lang=js"
export * from "./releaseDetail.vue?vue&type=script&lang=js"
import style0 from "./releaseDetail.vue?vue&type=style&index=0&id=518d22f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d22f4",
  null
  
)

export default component.exports